// =====================================================================
// Centralised TanStack Query key factory (CODE_STYLE §4, STACK §1.2).
// Every queryKey in the app is built here so invalidation is precise and
// keys never drift between producer (queryOptions) and consumer.
// =====================================================================

import type { CatalogFilters } from "@/shared/lib/db-schema";

export const keys = {
  product: {
    all: ["product"] as const,
    list: (filters: Partial<CatalogFilters>) => [...keys.product.all, "list", filters] as const,
    detail: (id: string) => [...keys.product.all, "detail", id] as const,
    images: (id: string) => [...keys.product.all, "images", id] as const,
    variants: (id: string) => [...keys.product.all, "variants", id] as const,
  },
  category: {
    all: ["category"] as const,
    tree: () => [...keys.category.all, "tree"] as const,
  },
  dictionary: {
    all: ["dictionary"] as const,
    kind: (kind: string) => [...keys.dictionary.all, kind] as const,
  },
  settings: {
    all: ["settings"] as const,
  },
  banner: {
    all: ["banner"] as const,
    active: () => [...keys.banner.all, "active"] as const,
  },
  promotion: {
    all: ["promotion"] as const,
    active: () => [...keys.promotion.all, "active"] as const,
  },
  order: {
    all: ["order"] as const,
    list: () => [...keys.order.all, "list"] as const,
    detail: (id: string) => [...keys.order.all, "detail", id] as const,
  },
  pickupPoint: {
    all: ["pickup-point"] as const,
    byId: (id: string) => [...keys.pickupPoint.all, "by-id", id] as const,
  },
  user: {
    all: ["user"] as const,
    current: () => [...keys.user.all, "current"] as const,
  },
} as const;
